import React from "react";

import { Grid } from "@material-ui/core";
import NumberOfStoresPerCategory from "./NumberOfStoresPerCategory";
import RetailComplexion from "./RetailComplexion";
import NumberOfStores from "./NumberOfStores";
import MostCommonStoreSize from "./MostCommonStoreSize";
import RetailZonesInfo from "./retailZonesInfo/RetailZonesInfo";
import ChainIndependentSplit from "./ChainIndependentSplit";
import ChainStatusFilter from "./ChainStatusFilter";
import StoreCategoriesFilter from "./StoreCategoriesFilter";
import StoreSizeFilter from "./StoreSizeFilter";
import UnclassifiedCategorySwitch from "./UnclassifiedCategorySwitch";
import IndependentsRateRAG from "./IndependentsRateRAG";
import BudgetAndValueOptionsRAG from "./BudgetAndValueOptionsRAG";
import RetailComplexionTitle from "./RetailComplexionTitle";

const RetailMix: React.FC = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <RetailZonesInfo />
            </Grid>
            <Grid item xs={4}>
                <StoreCategoriesFilter />
            </Grid>
            <Grid item xs={4}>
                <ChainStatusFilter />
            </Grid>
            <Grid item xs={4}>
                <StoreSizeFilter />
            </Grid>
            <Grid item xs={4}>
                <NumberOfStores />
            </Grid>
            <Grid item xs={4}>
                <ChainIndependentSplit />
            </Grid>
            <Grid item xs={4}>
                <MostCommonStoreSize />
            </Grid>
            <Grid item xs={12}>
                <NumberOfStoresPerCategory />
            </Grid>
            <Grid item xs={12}>
                <RetailComplexionTitle />
            </Grid>
            <Grid item xs={12}>
                <UnclassifiedCategorySwitch />
            </Grid>
            <Grid item xs={12}>
                <RetailComplexion />
            </Grid>
            <Grid item xs={12}>
                <IndependentsRateRAG />
            </Grid>
            <Grid item xs={12}>
                <BudgetAndValueOptionsRAG />
            </Grid>
        </Grid>
    );
};

export default RetailMix;
